import FundOpportunityContentCacheImpl, {
  placeholderImageItemContentItem,
} from '../FundOpportunityContentCacheImpl';

const fundOpportunityContentCache = new FundOpportunityContentCacheImpl();

// Re-export the setAssetStorageToken and clearAssetStorageToken methods
export const setAssetStorageToken = (token: import('TokenData').default) => {
  fundOpportunityContentCache.setAssetStorageToken(token);
};

export const clearAssetStorageToken = () => {
  fundOpportunityContentCache.clearAssetStorageToken();
};

export default fundOpportunityContentCache;
export { placeholderImageItemContentItem };
